module.exports = __webpack_public_path__ + "static/silver-raven-mtg_afr-b1df2bb41d26e7813c4fa33e31702f7e.jpg";